import {Outlet} from "react-router";

import "simplebar-react/dist/simplebar.min.css";
import "react-day-picker/dist/style.css";
import "leaflet/dist/leaflet.css";

import "@/assets/css/base/bootstrap.scss";
import "@/assets/css/base/layout.scss";
import "@/assets/css/base/theme.scss";
import "@/assets/css/styles/merged.css";

export default function AppLayout() {
    return <Outlet/>;
}
